import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { WorkoutService } from '../workout.service';
import { environment } from '../../../../../../src/environments/environment';
import { EToastType, HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
	selector: 'app-workout-library',
	templateUrl: './workout-library.component.html',
	styleUrls: ['./workout-library.component.scss']
})
export class WorkoutLibraryComponent implements OnInit {
	@Input() selectionInfo: any;
	@Output() creatNewWorkoutEventEmit: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() addWorkoutLibraryEventEmit: EventEmitter<any> = new EventEmitter<any>();
	@Output() editWorkoutLibraryEventEmit: EventEmitter<any> = new EventEmitter<any>();
	workoutLib: any;
	haloWebCloudURL: string = environment.haloWebCloudBasePath;
	savedGoalType: any;
	mylesTreadEquipment: any;
	private pageHeader = this.commonUtil.translateText('GENERAL.PRODUCT.SETTINGS');
	constructor(
		private commonUtil: CommonUtil,
		private workoutService: WorkoutService,
		private facilityService: FacilityService,
		private toast: HaloToastService,
		private loader: HaloLoaderService,
		private _amplitudeAnalytics: AmplitudeAnalyticsService
	) { }

	ngOnInit(): void {
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.selectionInfo && changes.selectionInfo.currentValue !== changes.selectionInfo.previousValue) {
			let selectionInfo = changes.selectionInfo.currentValue;
			this.mylesTreadEquipment = Number(changes.selectionInfo.currentValue.facility.summary.mylesTread);
			if (selectionInfo.activityId && selectionInfo.categoryId && selectionInfo.consoleType && selectionInfo.multiFacilities) {
				this.loadWorkOutLibrary();
			}
		}		
	}

	loadWorkOutLibrary() {
		this.workoutService.getWorkoutLibrary(this.selectionInfo.activityId, this.selectionInfo.categoryId, this.selectionInfo.consoleType, this.selectionInfo.multiFacilities).subscribe(val => {
			if(val && val.workoutLibrary){
				this.workoutLib = val.workoutLibrary;
			}else{
				this.createNewWorkout();
			}			
		});
	}

	getWorkoutParamValue(workoutParam: any) {
		let paramVal = parseFloat(workoutParam.paramValue);
		paramVal = paramVal % 1 == 0 ? Number(paramVal.toFixed(0)) : Number(paramVal.toFixed(1));
		if (workoutParam.paramId == 9) {
			if (paramVal == 0) {
				paramVal = this.commonUtil.translateText('LESS.THAN.5000FT');
			} else {
				paramVal = this.commonUtil.translateText('MORE.THAN.5000FT');
			}
		}
		else if (workoutParam.paramId == 40) {
			if (paramVal == 1) {
				paramVal = this.commonUtil.translateText('FLAT');
			} else if (paramVal == 2) {
				paramVal = this.commonUtil.translateText('RANDOM');
			} else if (paramVal == 3) {
				paramVal = this.commonUtil.translateText('HILLS');
			} else if (paramVal == 4) {
				paramVal = this.commonUtil.translateText('ROLLING.HILLS');
			}
		} else if (workoutParam.paramId == 41) {
			if (paramVal == 1) {
				paramVal = this.commonUtil.translateText('MODERATE.BURN');
			} else if (paramVal == 2) {
				paramVal = this.commonUtil.translateText('VIGOROUS.BURN');
			} else if (paramVal == 3) {
				paramVal = this.commonUtil.translateText('FIXED.TIME');
			} else if (paramVal == 4) {
				paramVal = this.commonUtil.translateText('VARIOUS.TIME');
			}
		}
		return paramVal;
	}

	paramsToDisplayInWorkoutLibrary(workoutParamObj: any, workoutLib: any) {
		if (this.savedGoalType != workoutParamObj.paramId) {
			for (var i = 0; i < workoutLib.workoutParamList.length; i++) {
				if (workoutLib.workoutParamList[i].goalTypeSelected) {
					this.savedGoalType = workoutLib.workoutParamList[i].paramId;
					break;
				}
			}
		}

		var fieldParamId = workoutParamObj.paramId;
		if (((workoutParamObj.goalType == "true" && workoutParamObj.goalTypeSelected) || typeof workoutParamObj.goalType == "undefined") && (fieldParamId != 1 && fieldParamId != 2 && fieldParamId != 3 && fieldParamId != 10 && fieldParamId != 18 && fieldParamId != 22 && fieldParamId != 23 && fieldParamId != 26 && fieldParamId != 27 && fieldParamId != 28 && fieldParamId != 29 && fieldParamId != 30)) {
			if (this.savedGoalType != 6 && (fieldParamId == 19 || fieldParamId == 20)) {
				return false;
			}
			if (workoutLib.workoutId == 18 && fieldParamId == 13)
				return false;
			if (workoutLib.workoutId == 1011 && fieldParamId == 14)
				return false;
			if (fieldParamId == 14 && ((typeof workoutParamObj.isHighVoltage != 'undefined' && workoutParamObj.isHighVoltage == 'true' && this.mylesTreadEquipment == 0) || (typeof workoutParamObj.isHighVoltage == 'undefined' && this.mylesTreadEquipment == 1)))
				return false;
			return true;
		}
		return false;
	}

	createNewWorkout(){
		this.creatNewWorkoutEventEmit.emit(true);
	}
	async onActionButtonClick(workoutLibrary:any,action:string) {
		if(action === "ADD"){
			this.addWorkoutLibraryEventEmit.emit(workoutLibrary);
		}else if(action === "DELETE"){
			if(workoutLibrary.inUse === 'true'){
				this.toast.creatToast(
					this.commonUtil.translateText('WORKOUT.DELETEWORKOUT.WARNING'),
					EToastType.ERROR
				  );				
			}else{
				this.loader.startProcess();
				try{
					this._amplitudeAnalytics.logEvent({elementName: 'Delete', action: "Click"});
					let resp = await this.workoutService.deleteWorkoutFromLib(workoutLibrary.id);
					this.loadWorkOutLibrary();
				}catch(error){
					console.log(error);
				}finally{
					this.loader.endProcess();
				}				
			}
		}else{
			workoutLibrary.facilityWorkoutId = workoutLibrary.id;
			this.editWorkoutLibraryEventEmit.emit(workoutLibrary);
		}
		
	}
}
